import { Outlet } from 'react-router';
import { Badge, Brand, ThemeToggle } from '@efira/ui';

import { useQuota } from '../api/queries';
import { LANDING_URL } from '../config';
import { QuotaChip } from './QuotaPanel';

/**
 * Оболочка прежних экранов зон - ВРЕМЕННАЯ, до конца этапа 2.
 *
 * Вкладки зон сняты 2026-09-18 вместе с моделью «семь вкладок»: она неверна,
 * стример в эфире смотрит на один экран. Сами экраны не удалены - их
 * содержимое переезжает в зоны консоли поштучно, и до переезда им нужно место,
 * где их видно и где их проверяют сквозные сценарии.
 *
 * Здесь нет ни вкладок, ни навигации: это не продуктовый экран, а склад с
 * дверью. Пользователь сюда не попадает - ссылок на /app/legacy в консоли нет.
 *
 * Что куда переезжает - docs/PHASE4_STATE.md, раздел о переезде зон. Оболочка
 * удаляется вместе с последним переехавшим экраном.
 */
export function LegacyZoneLayout() {
  const quota = useQuota();

  return (
    <div className="bg-muted/40 flex min-h-dvh flex-col">
      <header className="bg-background border-foreground/10 sticky top-0 z-40 border-b">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-3 sm:px-6">
          <Brand href={LANDING_URL} />
          <Badge variant="destructive" className="ms-2 whitespace-nowrap">
            Экран до переезда в консоль
          </Badge>
          {/*
            Остаток дневной квоты виден ВСЕГДА (Фаза 3, блок 6). Пока экраны
            живут здесь, показатель живёт здесь же; в консоль он переезжает
            первым на этапе 2 - docs/PHASE4_STATE.md.
          */}
          <div className="ms-auto flex items-center gap-2">
            <QuotaChip quota={quota.data} />
            <ThemeToggle />
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6 sm:px-6">
        <Outlet />
      </main>
    </div>
  );
}
